import './Page.scss'
import {BgDeco} from '../../global-styles/deco-styles/bg-deco/BgDeco'

export const Page = ({ children, id, pageDeco }) => {
    return (
        <div id={id} className="page">
            {pageDeco && <BgDeco />}
            {children}
        </div>
    )
}

export const PageHeader = ({ children }) => {
    return (
        <div className={'page-header'}>{children}</div>
    )
}

const Heading = ({ children }) => {
    return (
        <h1 className={'page-heading'}>{children}</h1>
    )
}
Page.Heading = Heading